// scrub-url.ts — remove one-time tokens from a URL before it reaches analytics.
//
// PortalSetPassword / PortalAgreementSign / PortalVerify / DetailsForm /
// staff-invite / intake links all carry a token that IS a credential. PostHog
// pageviews and Sentry events capture the full URL, so without this the token
// lands in analytics dashboards (and any breach of them). This keeps the route
// (so "client opened set-password" is still measured) but blanks the token.
const SECRET_KEYS = /^(token|code|jwt|key|secret|password|sig|signature|access_token)$/i;
const TOKEN_PATH = /\/(intake|details|staff-invite|disclosure|upload-docs|voe|document-requests|with|a)\/([A-Za-z0-9._-]{12,})/gi;

export function scrubUrl(input: string | null | undefined): string {
  if (!input) return input ?? "";
  try {
    const u = new URL(input, "https://placeholder.local");
    for (const k of [...u.searchParams.keys()]) {
      if (SECRET_KEYS.test(k)) u.searchParams.set(k, "[redacted]");
    }
    const path = u.pathname.replace(TOKEN_PATH, (_m, route) => `/${route}/[redacted]`);
    const qs = u.searchParams.toString().replace(/%5Bredacted%5D/gi, "[redacted]");
    const rebuilt = `${path}${qs ? "?" + qs : ""}${u.hash || ""}`;
    // Preserve absolute vs relative shape of the original.
    return /^https?:\/\//i.test(input) ? `${u.origin}${rebuilt}` : rebuilt;
  } catch {
    return input.replace(/([?&](?:token|code|jwt|key|secret|password|sig|signature|access_token)=)[^&#]+/gi, "$1[redacted]");
  }
}
